import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-echeck',
    templateUrl: '../svgs/eCheck.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--echeck'
    }
})
export class TellerOnlineIconECheck {
}